function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { merge } from 'lodash-es';
import Emitter from '../core/emitter.js';
import BaseTheme, { BaseTooltip } from './base.js';
import { Range } from '../core/selection.js';
import icons from '../ui/icons.js';
import Quill from '../core/quill.js';
var TOOLBAR_CONFIG = [['bold', 'italic', 'link'], [{
  header: 1
}, {
  header: 2
}, 'blockquote']];
var BubbleTooltip = /*#__PURE__*/function (_BaseTooltip) {
  _inherits(BubbleTooltip, _BaseTooltip);
  var _super = _createSuper(BubbleTooltip);
  function BubbleTooltip(quill, bounds) {
    var _this;
    _classCallCheck(this, BubbleTooltip);
    _this = _super.call(this, quill, bounds);
    _this.quill.on(Emitter.events.EDITOR_CHANGE, function (type, range, oldRange, source) {
      if (type !== Emitter.events.SELECTION_CHANGE) return;
      if (range != null && range.length > 0 && source === Emitter.sources.USER) {
        _this.show();
        // Lock our width so we will expand beyond our offsetParent boundaries
        _this.root.style.left = '0px';
        _this.root.style.width = '';
        _this.root.style.width = "".concat(_this.root.offsetWidth, "px");
        var lines = _this.quill.getLines(range.index, range.length);
        if (lines.length === 1) {
          var _bounds = _this.quill.getBounds(range);
          if (_bounds != null) {
            _this.position(_bounds);
          }
        } else {
          var lastLine = lines[lines.length - 1];
          var index = _this.quill.getIndex(lastLine);
          var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
          var indexBounds = _this.quill.getBounds(new Range(index, length));
          if (indexBounds != null) {
            _this.position(indexBounds);
          }
        }
      } else if (document.activeElement !== _this.textbox && _this.quill.hasFocus()) {
        _this.hide();
      }
    });
    return _this;
  }
  _createClass(BubbleTooltip, [{
    key: "listen",
    value: function listen() {
      var _this2 = this;
      _get(_getPrototypeOf(BubbleTooltip.prototype), "listen", this).call(this);
      // @ts-expect-error Fix me later
      this.root.querySelector('.ql-close').addEventListener('click', function () {
        _this2.root.classList.remove('ql-editing');
      });
      this.quill.on(Emitter.events.SCROLL_OPTIMIZE, function () {
        // Let selection be restored by toolbar handlers before repositioning
        setTimeout(function () {
          if (_this2.root.classList.contains('ql-hidden')) return;
          var range = _this2.quill.getSelection();
          if (range != null) {
            var bounds = _this2.quill.getBounds(range);
            if (bounds != null) {
              _this2.position(bounds);
            }
          }
        }, 1);
      });
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.show();
    }
  }, {
    key: "position",
    value: function position(reference) {
      var shift = _get(_getPrototypeOf(BubbleTooltip.prototype), "position", this).call(this, reference);
      var arrow = this.root.querySelector('.ql-tooltip-arrow');
      // @ts-expect-error
      arrow.style.marginLeft = '';
      if (shift !== 0) {
        // @ts-expect-error
        arrow.style.marginLeft = "".concat(-1 * shift - arrow.offsetWidth / 2, "px");
      }
      return shift;
    }
  }]);
  return BubbleTooltip;
}(BaseTooltip);
BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', '</div>'].join('');
var BubbleTheme = /*#__PURE__*/function (_BaseTheme) {
  _inherits(BubbleTheme, _BaseTheme);
  var _super2 = _createSuper(BubbleTheme);
  function BubbleTheme(quill, options) {
    var _this3;
    _classCallCheck(this, BubbleTheme);
    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
      options.modules.toolbar.container = TOOLBAR_CONFIG;
    }
    _this3 = _super2.call(this, quill, options);
    _this3.quill.container.classList.add('ql-bubble');
    return _this3;
  }
  _createClass(BubbleTheme, [{
    key: "extendToolbar",
    value: function extendToolbar(toolbar) {
      // @ts-expect-error
      this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
      if (toolbar.container != null) {
        this.tooltip.root.appendChild(toolbar.container);
        this.buildButtons(toolbar.container.querySelectorAll('button'), icons);
        this.buildPickers(toolbar.container.querySelectorAll('select'), icons);
      }
    }
  }]);
  return BubbleTheme;
}(BaseTheme);
BubbleTheme.DEFAULTS = merge({}, BaseTheme.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link: function link(value) {
          if (!value) {
            this.quill.format('link', false, Quill.sources.USER);
          } else {
            // @ts-expect-error
            this.quill.theme.tooltip.edit();
          }
        }
      }
    }
  }
});
export { BubbleTooltip, BubbleTheme as default };